var SmallGuideComponent = (function () {
    function SmallGuideComponent() {
    }
    SmallGuideComponent.prototype.ngOnInit = function () {
    };
    SmallGuideComponent.prototype.ngAfterViewInit = function () {
    };
    return SmallGuideComponent;
}());
export { SmallGuideComponent };



// WEBPACK FOOTER //
// ./src/app/small-guide/small-guide.component.ts.pre-build-optimizer.js